<template>
  <div
    class="widget-item"
    :class="[{preview: model === 'preview'},data.type,data.subType]"
  >
    <span class="title-wrapper">
      <span
        class="title"
        :title="data.name"
      >{{data.name}}</span>
      <div class="button-wrapper">
        <el-button
          type="iconButton"
          icon="h-icon-delete"
          class="inline-button"
          @click="removeWidget(data.id)"
          v-if="model === 'edit'&&data.type!=='todo'"
        ></el-button>
        <el-button
          type="iconButton"
          icon="h-icon-password_visible"
          class="inline-button"
          @click="previewWidget(data)"
        ></el-button>
        <el-button
          type="iconButton"
          icon="h-icon-edit"
          class="inline-button"
          @click="editWidget(data)"
          v-if="model === 'edit'&&data.type!=='todo'"
        ></el-button>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'widget-item',
  props: {
    data: Object,
    model: {
      type: String,
      default: 'view'
    }
  },
  methods: {
    removeWidget (data) {
      this.$emit('remove-widget', data)
    },
    editWidget (data) {
      this.$emit('edit-widget', data)
    },
    previewWidget (data) {
      this.$emit('preview-widget', data)
    }
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/mixin.less";

.widget-item {
  display: inline-block;
  width: 266px;
  height: 184px;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0 6px 16px;
  vertical-align: top;
  overflow: hidden;
  .title-wrapper {
    height: 32px;
    line-height: 32px;
    display: block;
    position: relative;
    font-size: 12px;
    color: #4c4c4c;
    .title {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 16px;
      margin-right: 102px;
    }
    .button-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      .inline-button {
        float: right;
        margin-left: 0;
        :hover {
          opacity: 0.8;
          filter: alpha(opacity=80);
        }
      }
      .el-button {
        background: none;
      }
    }
  }
  &.preview {
    margin: 0;
    border-radius: 0;
    .button-wrapper {
      display: none;
    }
  }
}
.navigation {
  background: url("../../assets/images/bg_widget_navigation.png") no-repeat
    center;
}
.chart.echarts-line {
  background: url("../../assets/images/bg_widget_line.png") no-repeat center;
}
.chart.echarts-bar {
  background: url("../../assets/images/bg_widget_bar.png") no-repeat center;
}
.chart.echarts-circle {
  background: url("../../assets/images/bg_widget_pie.png") no-repeat center;
}
.table {
  background: url("../../assets/images/bg_widget_table.png") no-repeat center;
}
.image {
  background: url("../../assets/images/bg_widget_image.png")
    no-repeat center;
}
.page {
  background: url("../../assets/images/bg_widget_page.png") no-repeat center;
}
.template {
  background: url("../../assets/images/home-config/bg_template.png") no-repeat
    center;
}
.widget-item.todo {
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/images/bg_widget_todo.png");
}
</style>
